import { onlyNumbers } from '@/utils/regex-utils';

const createDateFilter = (intialDate, finalDate, dateField) => {
  const filters = [];
  if (intialDate) filters.push(`${dateField} >= ${intialDate}`);
  if (finalDate) filters.push(`${dateField} <= ${finalDate}`);
  return filters.length ? `(${filters.join(' and ')})` : null;
};

export default {
  selectedStatus(state) {
    return state.selectedStatus;
  },
  statusOptions(state) {
    return state.statusOptions;
  },
  searchText(state) {
    return state.searchText;
  },
  empresa(state) {
    return state.empresa;
  },
  dataInicial(state) {
    return state.dataInicial;
  },
  dataFinal(state) {
    return state.dataFinal;
  },
  fornecedor(state) {
    return state.fornecedor;
  },
  listOptions(state) {
    return state.listOptions;
  },
  notasSemVinculo(state) {
    return state.notasSemVinculo;
  },
  hasCustomFilters(state) {
    return [
      state.empresa,
      state.dataFinal,
      state.dataInicial,
      state.notasSemVinculo,
      state.fornecedor && state.fornecedor.length,
    ].some(v => !!v);
  },
  stringFilter(state) {
    const filters = [];
    const dateFilter = createDateFilter(state.dataInicial, state.dataFinal, 'dataEmissao');
    if (dateFilter) {
      filters.push(`(${dateFilter})`);
    }
    if (state.selectedStatus && state.selectedStatus.value) {
      filters.push(state.selectedStatus.value());
    }
    if (state.searchText) {
      // usando apenas os números na busca pois todos os campos
      // (chave, cnpj emitente e destinatário) são numéricos
      const searchText = onlyNumbers(state.searchText);
      filters.push(`(chaveAcesso like '%${searchText}%' or cnpjEmitente like '%${searchText}%' or cnpjDestinatario like '%${searchText}%' or compra.codigoInterno like '%${state.searchText}%')`);
    }
    if (state.empresa && state.empresa.id) {
      filters.push(`(comprador.id = ${state.empresa.id})`);
    }
    if (state.fornecedor && state.fornecedor.length) {
      const fornecedorFilter = state.fornecedor.map(fornecedor => `(fornecedor.id = ${fornecedor.id})`);
      filters.push(`(${fornecedorFilter.join(' or ')})`);
    }
    if (state.notasSemVinculo) {
      filters.push('(semVinculo is true)');
    }

    return filters.join(' and  ');
  },
};
